var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"preview-ctr",style:({ background: _vm.layoutBackgroundColor }),attrs:{"direction":"vertical"}},[_c('header-comp',{attrs:{"headerConfig":_vm.headerConfig}}),_c('div',{staticClass:"fl-content-ctr"},[_c('div',{staticClass:"fl-content-ctr"},[_c('div',{staticClass:"comp-ctr"},[_c('el-row',{staticClass:"comp-row"},[_c('el-col',{attrs:{"span":12}},[_c('button',{staticClass:"el-button el-button--default",style:({
          background: _vm.primaryBackgroundColor,
          borderColor: _vm.primaryBorderColor,
          borderRadius: _vm.borderRadius
        }),attrs:{"type":"button"}},[_c('span',{style:({
            color: _vm.primaryColor
          })},[_vm._v("Primary")])])]),_c('el-col',{attrs:{"span":12}},[_c('el-button',{style:({
          background: _vm.primaryBackgroundHoverColor,
          borderColor: _vm.primaryBorderHoverColor,
          borderRadius: _vm.borderRadius
        })},[_c('span',{style:({
            color: _vm.primaryHoverColor
          })},[_vm._v("Primary Hover")])])],1)],1),_c('el-row',{staticClass:"comp-row"},[_c('el-col',{attrs:{"span":12}},[_c('el-button',{style:({
          background: _vm.secondaryBackgroundColor,
          borderColor: _vm.secondaryBorderColor,
          borderRadius: _vm.borderRadius
        })},[_c('span',{style:({
            color: _vm.secondaryColor
          })},[_vm._v("Secondary")])])],1),_c('el-col',{attrs:{"span":12}},[_c('el-button',{style:({
          background: _vm.secondaryBackgroundHoverColor,
          borderColor: _vm.secondaryBorderHoverColor,
          borderRadius: _vm.borderRadius
        })},[_c('span',{style:({
            color: _vm.secondaryHoverColor
          })},[_vm._v("Secondary Hover")])])],1)],1),_c('el-row',{staticClass:"comp-row"},[_c('el-col',{attrs:{"span":12}},[_c('el-button',{style:({
          background: _vm.deleteBackgroundColor,
          borderColor: _vm.deleteBorderColor,
          borderRadius: _vm.borderRadius
        })},[_c('span',{style:({
            color: _vm.deleteColor
          })},[_vm._v("Delete")])])],1),_c('el-col',{attrs:{"span":12}},[_c('el-button',{style:({
          background: _vm.deleteBackgroundHoverColor,
          borderColor: _vm.deleteBorderHoverColor,
          borderRadius: _vm.borderRadius
        })},[_c('span',{style:({
            color: _vm.deleteHoverColor
          })},[_vm._v("Delete Hover")])])],1)],1),_c('el-row',{staticClass:"comp-row"},[_c('el-col',[_c('div',{staticClass:"siteWrapper h_inst_button"},[_c('div',{staticClass:"siteButton",style:({
          background: _vm.instBackgroundColor
        })},[_c('div',{staticClass:"siteLogoImage"},[_c('img',{attrs:{"src":require("./../../assets/images/institution_logo/LOGO_2852_1_2.svg"),"alt":"Bank of America"}})]),_c('div',{staticClass:"siteDisplayName",style:({
          color: _vm.instColor
        })},[_vm._v("Bank of America")])])])])],1)],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }